let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("jRG5y")).then(() => parcelRequire('hBKGT'));